/**
 * Message from ANY thrown value. Supabase/PostgREST response errors are plain
 * `{ message, code, details, hint }` objects (postgrest-js only wraps them in
 * the PostgrestError class under `.throwOnError()`), so `instanceof Error`
 * checks silently drop DB guard messages — e.g. the Talent Pipeline
 * cross-pipeline NMLS guidance ("use Transfer to recruiting…").
 */
export function getErrorMessage(err: unknown, fallback = 'Unknown error occurred'): string {
  if (err instanceof Error) {
    return err.message || fallback;
  }
  if (err && typeof err === 'object' && 'message' in err) {
    const m = (err as { message?: unknown }).message;
    if (typeof m === 'string' && m.trim()) {
      return m;
    }
  }
  return fallback;
}
